
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { AppRoutingModule } from '../app.routing';
import { CareconformationComponent } from '../careconformation/careconformation.component';
import { NoAuthGuard } from '../forgotpwd/no-auth-guard.service';
import { CarepasswordComponent } from './carepassword.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
  imports: [
    AppRoutingModule,
    FormsModule,
    MatDialogModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    CarepasswordComponent,
    CareconformationComponent
  ],

  providers: [
    NoAuthGuard
  ],
  entryComponents: [
    CareconformationComponent
  ]
})
export class CarepasswordModule { }